import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'lib-persistence',
    template: `
    <p>
      persistence works!
    </p>
  `,
    styles: []
})
export class PersistenceComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
